const type = {
    USER_VIEW: 'USER_VIEW',
    USER_CREATE: 'USER_CREATE',
    USER_EDIT: 'USER_EDIT',
    USER_DELETE: 'USER_DELETE',

    ORGANIZATION_CREATE: 'ORGANIZATION_CREATE',
    ORGANIZATION_VIEW: 'ORGANIZATION_VIEW',
    ORGANIZATION_EDIT: 'ORGANIZATION_EDIT',
    ORGANIZATION_DELETE: 'ORGANIZATION_DELETE',

    TASK_VIEW: 'TASK_VIEW',
    TASK_CREATE: 'TASK_CREATE',
    TASK_EDIT: 'TASK_EDIT',
    TASK_DELETE: 'TASK_DELETE',

    OBJECT_VIEW: 'OBJECT_VIEW',
    OBJECT_CREATE: 'OBJECT_CREATE',
    OBJECT_EDIT: 'OBJECT_EDIT',
    OBJECT_DELETE: 'OBJECT_DELETE',

    EVENT_VIEW: 'EVENT_VIEW',
    EVENT_CREATE: 'EVENT_CREATE',
    EVENT_EDIT: 'EVENT_EDIT',
    EVENT_DELETE: 'EVENT_DELETE',

    MEDIA_VIEW: 'MEDIA_VIEW',
    MEDIA_CREATE: 'MEDIA_CREATE',
    MEDIA_EDIT: 'MEDIA_EDIT',
    MEDIA_DELETE: 'MEDIA_DELETE',

    REPORT_CREATE: 'REPORT_CREATE',
    REPORT_VIEW: 'REPORT_VIEW',
    REPORT_DELETE: 'REPTE_DELETE',
    REPORT_EDIT: 'REPORT_EDIT',

    OTHER_RESET_PASSWORD: 'OTHER_RESET_PASSWORD',
    OTHER_BAN_USER: 'OTHER_BAN_USER',

    ALL: 'ALL',
    ONLY_SUPER_ADMIN: 'ONLY_SUPER_ADMIN'
}

const modules = [
    {
        name: "Quản lý người dùng",
        actions: [
            {
                type: type.USER_VIEW,
                name: "Xem"
            },
            {
                type: type.USER_CREATE,
                name: "Thêm"
            },
            {
                type: type.USER_EDIT,
                name: "Sửa"
            },
            {
                type: type.USER_DELETE,
                name: "Xoá"
            }
        ]
    },
    {
        name: "Quản lý đơn vị",
        actions: [
            {
                type: type.ORGANIZATION_VIEW,
                name: "Xem"
            },
            {
                type: type.ORGANIZATION_CREATE,
                name: "Thêm"
            },
            {
                type: type.ORGANIZATION_EDIT,
                name: "Sửa"
            },
            {
                type: type.ORGANIZATION_DELETE,
                name: "Xoá"
            }
        ]
    },
    {
        name: "Quản lý nhiệm vụ",
        actions: [
            {
                type: type.TASK_VIEW,
                name: "Xem"
            },
            {
                type: type.TASK_CREATE,
                name: "Thêm"
            },
            {
                type: type.TASK_EDIT,
                name: "Sửa"
            },
            {
                type: type.TASK_DELETE,
                name: "Xoá"
            }
        ]
    },
    {
        name: "Quản lý đối tượng",
        actions: [
            {
                type: type.OBJECT_VIEW,
                name: "Xem"
            },
            {
                type: type.OBJECT_CREATE,
                name: "Thêm"
            },
            {
                type: type.OBJECT_EDIT,
                name: "Sửa"
            },
            {
                type: type.OBJECT_DELETE,
                name: "Xoá"
            }
        ]
    },
    {
        name: "Quản lý sự kiện",
        actions: [
            {
                type: type.EVENT_VIEW,
                name: "Xem"
            },
            {
                type: type.EVENT_CREATE,
                name: "Thêm"
            },
            {
                type: type.EVENT_EDIT,
                name: "Sửa"
            },
            {
                type: type.EVENT_DELETE,
                name: "Xoá"
            }
        ]
    },
    {
        name: "Quản lý tài liệu",
        actions: [
            {
                type: type.MEDIA_VIEW,
                name: "Xem"
            },
            {
                type: type.MEDIA_CREATE,
                name: "Thêm"
            },
            {
                type: type.MEDIA_EDIT,
                name: "Sửa"
            },
            {
                type: type.MEDIA_DELETE,
                name: "Xoá"
            }
        ]
    },
    {
        name: "Báo cáo",
        actions: [
            {
                type: type.REPORT_VIEW,
                name: "Xem"
            },
            {
                type: type.REPORT_CREATE,
                name: "Thêm"
            },
            {
                type: type.REPORT_EDIT,
                name: "Sửa"
            },
            {
                type: type.REPORT_DELETE,
                name: "Xoá"
            }
        ]
    },
    {
        name: "Quyền khác",
        actions: [
            {
                type: type.OTHER_RESET_PASSWORD,
                name: "Reset mật khẩu người dùng"
            },
            {
                type: type.OTHER_BAN_USER,
                name: "Cấm người dùng"
            },
        ] 
    }
]

export {
    type,
    modules
}